import {
  GET_COMPLIANCE_FAILURE,
  GET_COMPLIANCE_REQUEST,
  GET_COMPLIANCE_SUCCESS,

} from "./complianceTypes";

const initialState = {
  loading: false,
  compliance: [],
  error: "",
};

const getComplianceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPLIANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPLIANCE_SUCCESS:
      return {
        loading: false,
        compliance: action.payload,
        error: "",
      };
    case GET_COMPLIANCE_FAILURE:
      return {
        loading: false,
        compliance: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   documentType: [],
//   error: "",
// };

// const getDocumentTypeWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         documentType: action.payload,
//         error: "",
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         documentType: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export {
  getComplianceReducer,
  //  getDocumentTypeWithPaginationReducer
};
